<template>
  <section class="l-section wpb_row height_small mpc-row">
    <div class="l-section-h i-cf">
      <div class="g-cols type_default valign_top">
        <div class="vc_col-sm-12 wpb_column vc_column_container mpc-column"
             data-column-id="mpc_column-65e8067f246b92">
          <div class="vc_column-inner  vc_custom_1491815585182">
            <div class="wpb_wrapper">
              <div class="vc_empty_space" style="height: 32px">
                <span class="vc_empty_space_inner"></span>
              </div>
              <div class="wpb_text_column ">
                <div class="wpb_wrapper">
                  <p style="text-align: center;">
                    <span style="font-size: 22px;">{{ $t('Телефон') }}</span>
                  </p>
                </div>
              </div>
              <div class="g-cols wpb_row type_default valign_top vc_inner mpc-row">
                <div class="vc_col-sm-12 wpb_column vc_column_container mpc-column"
                     data-column-id="mpc_column-65e8067f24695a">
                  <div class="vc_column-inner">
                    <div class="wpb_wrapper">
                      <div class="wpb_text_column ">
                        <div class="wpb_wrapper">
                          <p style="text-align: center;">
                            <a :href="`tel:${settings.phone}`">
                              <i class="fa fa-phone"
                                 style="margin-right: 5px; font-size: 22px; vertical-align: middle; margin-top: -2px"></i>
                              <span>{{ settings.phone }}</span>
                            </a>
                          </p>
                          <p style="text-align: center;">
                            {{ $t('Дзвінки з будь – яких операторів безкоштовні!') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'PhoneSection',
    computed: {
      ...mapState('settings', ['settings'])
    }
  }
</script>

<style>

</style>
